// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css
.import-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 10px;
}

.import-table th,
.import-table td {
    padding: 10px;
    text-align: left;
    word-wrap: break-word;
}

.import-table tr,
.import-table td {
    padding: 20px;
}

.import-table th {
    background-color: #f4f4f4;
    border: none;
}

.import-table td {
    border: none;
    color: rgba(59, 69, 79, 1);
}

.import-table tr {
    background-color: #fff;
    overflow: hidden;
    font-weight: 600;
    font-size: 16px;
}

.import-table-row {
    box-shadow: 0px 2px 5px 2px #B9B9B9 !important;
}

.import-table-row tr:first-child {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}

.import-table-row tr:last-child {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
} */`, "",{"version":3,"sources":["webpack://./src/components/pages/Import/ImportFarmer/ImportFarmer.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgDG","sourcesContent":["/* styles.css\n.import-table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0 10px;\n}\n\n.import-table th,\n.import-table td {\n    padding: 10px;\n    text-align: left;\n    word-wrap: break-word;\n}\n\n.import-table tr,\n.import-table td {\n    padding: 20px;\n}\n\n.import-table th {\n    background-color: #f4f4f4;\n    border: none;\n}\n\n.import-table td {\n    border: none;\n    color: rgba(59, 69, 79, 1);\n}\n\n.import-table tr {\n    background-color: #fff;\n    overflow: hidden;\n    font-weight: 600;\n    font-size: 16px;\n}\n\n.import-table-row {\n    box-shadow: 0px 2px 5px 2px #B9B9B9 !important;\n}\n\n.import-table-row tr:first-child {\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n}\n\n.import-table-row tr:last-child {\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
